import {
  Backdrop,
  Button,
  CircularProgress,
  colors,
  Container,
  Snackbar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tab,
  Tabs
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';
import Page from 'src/components/Page';
import {
  getDefectRequest,
  getLabourRequest,
  getMaterialRequest
} from '../../store/actions';
import { addDefects, resetDefects } from '../../store/actions/defectActions';
import { addLabours, resetLabours } from '../../store/actions/labourActions';
import {
  addMaterials,
  resetMaterials
} from '../../store/actions/materialActions';
import { setTask } from '../../store/actions/taskActions';
import Survey from './Survey';
import Header from './Header';
import Summary from './Summary';
import TechnicalSupport from './TechnicalSupport';
import WorkOrderEnd from './WorkOrderEnd';
import Alert from 'src/components/Alert';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  tabs: {
    marginTop: theme.spacing(1)
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: {
    marginTop: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));

function Isler({
  match,
  history,
  tasks,
  defectReducer,
  labourReducer,
  materialReducer,
  setTask
}) {
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState('');
  const [Loading, setLoading] = useState(false);
  const [readonly, setReadonly] = useState(false);
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const { id, tab: currentTab } = match.params;
  const [Data, setData] = React.useState([]);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [ResponseType, setResponseType] = useState('success');
  const [ResponseDsc, setResponseDsc] = useState('');
  const SessionUser = getUser();
  var TitleApp = "Sirius Partner";

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  const Alltabs = [
    {
      value: 'summary',
      index: 0,
      label: t('lblWorkOrderTab'),
      visible: true,
      component: <Summary ReceiptNo={id} readonly={readonly} />
    },
    {
      value: 'WorkOrderEnd',
      index: 1,
      label: t('Sonlandir'),
      visible: true,
      component: (
        <WorkOrderEnd
          ReceiptNo={id}
          readonly={readonly}
          setReadonly={setReadonly}
        />
      )
    },
    {
      value: 'Anket',
      index: 2,
      label: t('Anket'),
      visible: false,
      component: <Survey ReceiptNo={id} readonly={readonly} />
    },
    {
      value: 'Yardimci',
      index: 3,
      label: t('T_Destek'),
      visible: true,
      component: <TechnicalSupport ReceiptNo={id} readonly={readonly} setOpenSnackbar={setOpenSnackbar} setResponseDsc={setResponseDsc} setResponseType={setResponseType} />
    }
  ];

  const tabs = Alltabs.filter(t => t.visible).map((t, i) => {
    return { ...t, index: i };
  });
  const handleClose = () => {
    setOpen(false);
    history.push('/overview');
  };
  useEffect(() => {
    if (!tasks.loading) {
      if (tasks?.tasks.length === 0) {
        const informationAlert = t('Fis_Bulunamadi').replace('@FisNo', id);
        setUyari(informationAlert);
        setOpen(true);
      } else {
        const jobs = tasks?.tasks?.filter(
          d => parseInt(d.ReceiptNo) === parseInt(id)
        );
        if (jobs.length === 0) {
          const informationAlert = t('Fis_Bulunamadi').replace('@FisNo', id);
          setUyari(informationAlert);
          setOpen(true);
        } else {
          setData(jobs);
        }
      }
    }
    // eslint-disable-next-line
  }, [history, id, tasks.loading, tasks.tasks]);

  let currentTabIndex = 0;

  if (currentTab !== undefined) {
    currentTabIndex = tabs.filter(d => d.value === currentTab)[0].index;
  }
  const [index, setindex] = useState(currentTabIndex);

  useEffect(() => {
    let mounted = true;
    const fetchTodos = () => {
      if (mounted) {
        setindex(currentTabIndex);
        // if (currentTabIndex === 1 || currentTabIndex === 2) {
          if (defectReducer.Data.length === 0) {
            return;
          }
          let job = Data[0];
          const hizmetlerH = [];
          const isciliklerH = [];
          const malzemelerH = [];
          let iscilik_toplam = 0;
          let malzeme_toplam = 0;
   
          for (let h = 0; h < defectReducer.selected.length; h++) {
            const hizmet = defectReducer.selected[h];
            const hizmetRedux = defectReducer.defectsTable[hizmet];
            hizmetlerH.push({
              DefectId: hizmet,
              DefectCode: hizmetRedux?.UserCode,
              DefectDesc: hizmetRedux?.DefectDesc
            });
            const labourArray = labourReducer[hizmet];
            if (labourArray && labourArray.length > 0) {
              for (let i = 0; i < labourArray.length; i++) {
                const iscilik = labourReducer.Data.filter(
                  d => d.LabourCode === labourArray[i]
                )[0];
                if (iscilik) {
                  isciliklerH.push({
                    LabourId: iscilik.LabourId,
                    DefectId: hizmet,
                    LabourCode: iscilik.LabourCode,
                    LabourDesc: iscilik.LabourDesc,
                    Price: iscilik.Price,
                    PriceWithWat: iscilik.PriceWithWat,
                    VatRate: iscilik.VatRate,
                    VatId: iscilik.VatId,
                    LabourPriceId: iscilik.PriceId
                  });
                  iscilik_toplam += iscilik.PriceWithWat
                }
              }
            }
            const materialArray = materialReducer[hizmet];
            if (materialArray && materialArray.length > 0) {
              for (let m = 0; m < materialArray.length; m++) {
                const malzeme = materialReducer.Data.filter(
                  d => d.MaterialCode === materialArray[m]
                )[0];
                if (malzeme) {
                  malzemelerH.push({
                    MaterialId: malzeme.MaterialId,
                    DefectId: hizmet,
                    DefectDesc : hizmetRedux?.CategoryLevel1+"/"+hizmetRedux?.CategoryLevel2+"/"+hizmetRedux?.UserCode+"/"+hizmetRedux?.DefectDesc,
                    MaterialCode: malzeme.MaterialCode,
                    Count: materialReducer[malzeme.MaterialCode],
                    MaterialDesc: malzeme.MaterialDesc,
                    Price: malzeme.Price,
                    PriceWithWat: malzeme.PriceWithWat,
                    VatRate: malzeme.VatRate,
                    VatId: malzeme.VatId,
                    MaterialPriceListId: malzeme.PriceListId,
                    MaterialPriceId: malzeme.PriceId
                  });
                  malzeme_toplam += materialReducer[malzeme.MaterialCode] * malzeme.PriceWithWat;

                }
              }
            }
          }

          // seçileni taska yaz
          job = {
            ...job,
            WorkOrderDetails: hizmetlerH,
            WorkOrderLabours: isciliklerH,
            WorkOrderMaterials: malzemelerH,
            EMploymentCostTotal: iscilik_toplam,
            MaterialTotal: malzeme_toplam
          };
          setTask(job);
        }
      // }
    };
    fetchTodos();
    return () => {
      mounted = false;
    };
  }, [currentTabIndex, materialReducer]);

  const handleChangeIndex = index => {
    const indexValueId = tabs.filter(d => d.index === index)[0].value;
    history.push(indexValueId);
  };
  const handleChange = (event, value) => {
    const indexValue = tabs.filter(d => d.index === value)[0].value;
    history.push(indexValue);
  };

  return (
    <Page className={classes.root} title={TitleApp}>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          message={ResponseDsc}
          variant={ResponseType}
        />
      </Snackbar>
      <Backdrop className={classes.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container maxWidth="xl">
        <Header ReceiptNo={id} readonly={readonly} Data={Data} />
        <Tabs
          value={index}
          className={classes.tabs}
          textColor="secondary"
          scrollButtons="on"
          indicatorColor="primary"
          variant="scrollable"
          onChange={handleChange}
        >
          {tabs.map(t => {
            return (
              t.visible && <Tab key={t.index} label={t.label} value={t.index} />
            );
          })}
        </Tabs>
        <SwipeableViews index={index} onChangeIndex={handleChangeIndex}>
          {tabs.map(t => {
            return t.visible && currentTab === t.value ? (
              <div key={t.index}>{t.component}</div>
            ) : (
              <div key={t.index} />
            );
          })}
        </SwipeableViews>
      </Container>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('Bilgilendirme')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

Isler.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default connect(
  state => ({
    tasks: state.tasks1,
    defectReducer: state.defectReducer,
    labourReducer: state.labourReducer,
    materialReducer: state.materialReducer
  }),
  {
    resetDefects,
    resetLabours,
    resetMaterials,
    addDefects,
    addLabours,
    addMaterials,
    getDefectRequest,
    getLabourRequest,
    getMaterialRequest,
    setTask
  }
)(Isler);
